import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("fz_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";
    const isAuthExpired =
      status === 401 &&
      (detail === "Token expired" || detail === "Invalid token") &&
      typeof window !== "undefined";
    if (isAuthExpired) {
      localStorage.removeItem("fz_token");
      localStorage.removeItem("fz_email");
      if (!window.location.pathname.startsWith("/admin/login")) {
        const next = encodeURIComponent(window.location.pathname);
        window.location.href = `/admin/login?expired=1&next=${next}`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
